import { configureStore } from '@reduxjs/toolkit';
import carts from '@/lib/carts';
import unitLimitIds from '@/lib/unitLimitId'
import typeElements from './typeElements';
import cartPopUp from '@/lib/cartPopUp';
import newsletterPopUp from '@/lib/newsletterPopUp';

export const store = configureStore({
  reducer: {
   // faqs: faqs,
   // advantages: advantages,
  //  shopifyprod: shopifyprod,
    //orders: orders,
    carts: carts,
    unitLimitIds: unitLimitIds,
    //shopifydiscount: shopifydiscount,
    typeElements: typeElements,
    cartPopUp: cartPopUp,
    newsletterPopUp: newsletterPopUp,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: true,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
